import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Dropzone = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '32px',
  border: `2px dashed ${theme.palette.divider}`,
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'border-color 0.2s ease',
  '&:hover': { borderColor: theme.palette.primary.main },
  '&.active': { borderColor: theme.palette.primary.main, backgroundColor: theme.palette.action.hover },
}));
